import React from 'react';

/**
 * Converts URLs in text to clickable links
 * @param text The text that may contain URLs
 * @returns React elements with clickable links
 */
export function linkify(text: string): React.ReactNode {
  if (!text) return '';
  
  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  
  // Replace URLs with React elements
  const elements: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;
  
  // Create a new regex object for iteration
  const regex = new RegExp(urlRegex);
  
  // Find each match and build the result array
  while ((match = regex.exec(text)) !== null) {
    // Add text before the match
    if (match.index > lastIndex) {
      elements.push(text.substring(lastIndex, match.index));
    }
    
    // Add the URL as a link
    elements.push(
      <a 
        key={match.index} 
        href={match[0]} 
        target="_blank"
        className="text-blue-600 hover:underline"
      >
        {match[0]}
      </a>
    );
    
    lastIndex = regex.lastIndex;
  }
  
  // Add any remaining text
  if (lastIndex < text.length) {
    elements.push(text.substring(lastIndex));
  }
  
  return elements.length > 0 ? elements : text;
}